import {Component} from '@angular/core';

@Component({
    selector: 'vui-modal-dialog-content',
    templateUrl: './modal-dialog-content.component.html',
    styleUrls: ['./modal-dialog-content.component.scss']
})
export class ModalDialogContentComponent {

}
